export default __webpack_public_path__ + "static/media/VLSD LOGO.3eb2f4eb.png";